<template>
    <v-app id="app">
        <v-app-bar app clipped-left color="secondary">
            <v-app-bar-nav-icon @click="mini = !mini" class="white--text"></v-app-bar-nav-icon>
            <span class="title ml-3 mr-5 white--text">Loan&nbsp;<span class="font-weight-light">Engine</span></span>
            <v-spacer></v-spacer>
            <v-text-field solo flat hide-details label="Search" prepend-inner-icon="mdi-magnify" class="white--text"></v-text-field>
            <v-spacer></v-spacer>
        </v-app-bar>
     <!--    <v-hover :default="{mini}"> -->
       <!--  <v-navigation-drawer ref="navDrawer" v-model="drawer" mobile-break-point="820" :expand-on-hover="true" :mini-variant.sync="mini" permanent fixed app clipped> -->
        <v-navigation-drawer permanent fixed app clipped hide-overlay v-model="drawer" mobile-break-point="820" :temporary="hover && mini" :slot-scope="{ hover }" :mini-variant="mini && !hover">
            <!--             <v-btn icon @click.stop="mini = !mini">
                <v-icon v-show="!mini">mdi-chevron-left</v-icon>
                <v-icon v-show="mini">mdi-chevron-right</v-icon>
            </v-btn> -->
            <v-layout align-center justify-center>
                <v-btn class="mt-6 px-0" large rounded :elevation="6" :min-width="0" @click="openFileInput()">
                    <v-list-item class="px-3">
                        <v-list-item-action class="mr-0">
                            <v-icon class="primary--text">
                                mdi-upload
                            </v-icon>
                            <input type="file" ref="file" style="display: none">
                        </v-list-item-action>
                        <v-list-item-content class="ml-2">
                            <span>
                                Upload
                            </span>
                        </v-list-item-content>
                    </v-list-item>
                </v-btn>
            </v-layout>
            <template v-for="(item, i) in items">
                <v-layout v-if="item.heading" :key="i" align-center>
                    <v-flex xs6>
                        <v-subheader v-if="item.heading">
                            {{ item.heading }}
                        </v-subheader>
                    </v-flex>
                    <v-flex xs6 class="text-right">
                        <v-btn small text>edit</v-btn>
                    </v-flex>
                </v-layout>
                <v-divider v-else-if="item.divider" :key="i" dark class="my-4"></v-divider>
                <v-list-item ripple v-else :key="i" @click="">
                    <v-list-item-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="">
                            {{ item.text }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-navigation-drawer>
    <!-- </v-hover> -->
        <utkCards>
        </utkCards>
        <v-overlay :value="overlay" ref="dropzone" style="visibility:hidden; opacity:0;">
            <div class="overlay-cta">
                <v-icon size='150' class='d-inline white--text'>mdi-cloud</v-icon>
                <h1>Drop files here</h1>
            </div>
            <v-btn icon @click="overlay = false" absolute top right>
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-overlay>
        <v-card v-show="uploading" transition="slide-y-reverse-transition" style="position:fixed; bottom:2vh; right:2vw; width:20rem;">
             <v-btn icon @click="uploading = false" absolute top right>
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-card-text>
                Uploading...
                <v-progress-linear :value="progress"></v-progress-linear>
                <h3>{{}}</h3>
            </v-card-text>
        </v-card>
       
    </v-app>
</template>
<script>
import utkCards from './components/Cards/Cards.vue';


export default {

    props: {
        source: String,
    },
    components: {
        utkCards,

    },
    created() {
        this.$vuetify.theme.dark = false
    },
    data: () => ({
        drawer: true,
        mini: true,
        hover: false,
        overlay: true,
        uploading: false,
        progress: 0,
        items: [
            { divider: true },
            { icon: 'mdi-lightbulb-outline', text: 'Home' },
            { icon: 'mdi-cursor-pointer', text: 'Document Management' },
            { icon: 'mdi-archive', text: 'HCD Credentials' },
            { icon: 'mdi-delete', text: 'Signer Info' },
            { icon: 'mdi-settings', text: 'Reformatting Rules' },
            { icon: 'mdi-format-align-right', text: 'Step Mapping' },
            { divider: true },
            { icon: 'mdi-chat-bubble', text: 'Trash' },
            { icon: 'mdi-help', text: 'Help' },
        ],

    }),
    methods: {
        openFileInput: function(e){
            // this.$refs.fileInput.click();
            this.$refs.file.click();

        },

        uploadFiles: function(file, e) {
            var self = this;
            self.progress = 0;
            self.uploading = true;
            var files = file.dataTransfer.files;
            console.log(files);

            var file = setInterval(status, 30);
            function status() {
                if (self.progress == 100) {
                    clearInterval(file);
                    console.log("Turkey's done");

                } else {
                    self.progress++;
                };
            };
        },
    },
    mounted() {
        var self = this;

        document.querySelector('nav.v-navigation-drawer').addEventListener("mouseover", function(e){
            e.preventDefault();
            self.mini = false;
        });
        document.querySelector('nav.v-navigation-drawer').addEventListener("mouseout", function(e){
            e.preventDefault();
            self.mini = true;
        });
        document.querySelector('nav.v-navigation-drawer .v-list-item').addEventListener("onClick", function(e){
            e.preventDefault();
            self.mini = true;
        });
        window.addEventListener("dragenter", function(e) {
            e.preventDefault();
            document.querySelector(".v-overlay").style.visibility = "visible";
            document.querySelector(".v-overlay").style.opacity = 1;
        });

        window.addEventListener("dragleave", function(e) {
            e.preventDefault();
            document.querySelector(".v-overlay").style.visibility = "hidden";
            document.querySelector(".v-overlay").style.opacity = 0;
        });

        window.addEventListener("dragover", function(e) {
            e.preventDefault();
            document.querySelector(".v-overlay").style.visibility = "visible";
            document.querySelector(".v-overlay").style.opacity = 1;
        });

        window.addEventListener("drop", function(e) {
            e.preventDefault();
            document.querySelector(".v-overlay").style.visibility = "hidden";
            document.querySelector(".v-overlay").style.opacity = 0;
            self.uploadFiles(e);
        });
    }
};
</script>
<style>
#app .v-navigation-drawer__border {
    display: none
}

.v-overlay {
    pointer-events: none;
}

.overlay-cta {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    border-radius: 100%;
    height: auto;
    width: auto;
    min-width: 24rem;
    min-height: 24rem;
    background: radial-gradient(hsla(214, 74%, 47%, 1) 40%, rgba(19, 67, 130, 1));
    color: white;
    animation: shadow-pulse 1s infinite;


}


@keyframes shadow-pulse {
    0% {
        box-shadow: 0 0 0 0px rgba(256, 256, 256, 0.1);
    }

    50% {}

    100% {

        box-shadow: 0 0 0 70px rgba(256, 256, 256, 0);
    }
}
</style>